import { loadScript } from '@/scripts/helpers/scriptLoader.helper';

let msalApp = null;

const MSAL_SCRIPT_URL = 'https://alcdn.msauth.net/browser/2.37.0/js/msal-browser.min.js';

const msalConfig = (clientId, tenantId, redirectionUri) => ({
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: redirectionUri,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  }
});

const createMsalInstance = async (clientId, tenantId, redirectionUri) => {
  if (!msalApp) {
    await loadScript(MSAL_SCRIPT_URL);
    msalApp = new window.msal.PublicClientApplication(
      msalConfig(clientId, tenantId, redirectionUri)
    );
  }
  return msalApp;
};

const getMsalInstance = () => msalApp;

export { createMsalInstance, getMsalInstance };